import { useEffect, useState } from 'react';
const useMobile = () => {
  const [mobile, setMobile] = useState(() => window.innerWidth <= 480);
  useEffect(() => { const resize = () => setMobile(window.innerWidth <= 480); window.addEventListener('resize', resize); return () => window.removeEventListener('resize', resize); }, []);
  return mobile;
};
export default useMobile;
